export const YMAPS_MODULES: string[] = [
  'Map',
  'ObjectManager',
  'shape.Rectangle',
  'geometry.pixel.Rectangle',
  'geolocation',
  'behavior.Ruler',
  'hotspot.Layer',
  'GeoObject',
  'Polygon',
  'templateLayoutFactory',
  'Balloon',
];

export const MODULES: string[] = [
  ...YMAPS_MODULES,
  // Наши
  'PointsLayer',
  'InfrastructurePointsLayer',
  'InfrastructureHTMLPointsLayer',
  'cian.DrawPolygon',
  'HotspotsLayer',
  'BalloonManager',
  'BalloonPromoManager',
  'PopupManager',
  'NewbuildingsPolygonsManager',
  'NewbuildingsPromoPinsManager',
  'NewbuildingPromoPopupManager',
];

export const MIN_PULSE_RADIUS = 2;
export const MAP_DETAILS_VISIBLE_PRECISION = 10;
export const TILE_SIZE = 256;
export const POINT_RADIUS = 7;
export const POINT_PEAS_RADIUS = 6;
export const POINT_SHADOW_X_RADIUS = 8;
export const POINT_SHADOW_Y_RADIUS = 3.5;
export const POINT_SHADOW_Y_OFFSET = 4.5;
export const DOT_SIZE_SMALL = 8;
export const DOT_SIZE_SMALL_REDESIGN = 6;
export const DOT_SIZE_BIG = 11;

export const POINT_COLORS = {
  white: '#fff',
  lightGreen: '#97da7c',
  regularGreen: '#34ac0a',
  hoveredGreen: '#227e01',
  activeGreen: '#1c6f01',
  lightBlue: '#83b4ff',
  regularBlue: '#0468ff',
  hoveredBlue: '#0661ec',
  activeBlue: '#0253c4',
  dark: '#152242',
  textBlue: '#0661ec',
  textGreen: '#227e01',
};

export const EXTENDED_POINT_RADIUS = 5.5;
export const EXTENDED_POINT_BORDER_WIDTH = 1.5;

export const REDESIGNED_POINT_RADIUS = 6;
export const POINT_BORDER_WIDTH = 1.5;

export const POINT_WITH_COUNT_RADIUS = 11;
export const POINT_WITH_COUNT_BORDER_WIDTH = 2;

export const POINT_GLOW_RADIUS = REDESIGNED_POINT_RADIUS + 4;
export const POINT_COUNT_MIN_VALUE = 2;
export const POINT_COUNT_MAX_VALUE = 99;

export const BALLOON_HOVERED_Z_INDEX = 700;
export const BALLOON_ACTIVE_Z_INDEX = 701;
export const BALLOON_Z_INDEX = 1;
export const BALLOON_PROMO_Z_INDEX = 2;
